export const LARAVEL_JETSTREAM_DEVEL_IMPORT_YAML = `#yamlPreprocessor=on
project:
  name: laravel-jetstream-devel
  tags:
    - zerops-recipe
    - development

services:
  - hostname: app
    type: php-nginx@8.4
    buildFromGit: https://github.com/zeropsio/recipe-laravel-jetstream
    enableSubdomainAccess: true
    envSecrets:
      APP_NAME: ZeropsLaravelJetstreamDev
      APP_DEBUG: true
      APP_ENV: development
      APP_KEY: <@generateRandomString(<32>)>
    verticalAutoscaling:
      minRam: 0.25
      minFreeRamGB: 0.125

  - hostname: db
    type: postgresql@16
    mode: NON_HA
    priority: 10

  - hostname: redis
    type: valkey@7.2
    mode: NON_HA
    priority: 10

  - hostname: storage
    type: object-storage
    objectStorageSize: 2
    objectStoragePolicy: public-read
    priority: 10

  - hostname: mailpit
    type: go@1
    buildFromGit: https://github.com/zeropsio/recipe-mailpit
    enableSubdomainAccess: true`;
